// 印度语
export default {
    Language: 'हिन्दी',
    system: {
        homePage: {
            title1: 'शीर्षक 1',
            title2: 'शीर्षक 2',
            description1: 'पिछले 7 दिन',
            description2: 'पिछले 6 महीने',
        }
    },
    login: {
        register: 'सदस्य पंजीकरण',
        usernamePls: 'कृपया उपयोगकर्ता नाम दर्ज करें',
        passwordPls: 'कृपया पासवर्ड दर्ज करें',
        toRegister: 'खाता नहीं है? अभी पंजीकरण करें',
        doLogin: 'लॉगिन',
    },
    register: {
        repasswordPls: 'कृपया निकासी पासवर्ड दर्ज करें',
        codePls: 'कृपया आमंत्रण कोड दर्ज करें',
        register: 'पंजीकरण',
        xieyi: 'उपयोग की शर्तों से सहमत',
        xieyiPls: 'कृपया नीचे खाता खोलने समझौता चुनें!',
    },
    mine: {
        xyfs: 'क्रेडिट स्कोर',
        ljjf: 'संचित अंक',
        recharge: 'रिचार्ज',
        withdraw: 'निकासी',
        money: 'उपलब्ध शेष',
        infomation: 'मूल जानकारी',
        moneylog: 'अंक रिकॉर्ड',
        withdrawrecord: 'निकासी विवरण',
        gamerecord: 'उपहार रिकॉर्ड',
        notice: 'सूचना',
        mymove: 'देखने का रिकॉर्ड',
        loginpwd: 'लॉगिन पासवर्ड',
        paypwd: 'उपयोग पासवर्ड',
        loginout: 'लॉगआउट',
        paypwdhasseted: 'निकासी पासवर्ड सेट हो चुका है। यदि बदलना चाहते हैं, तो कृपया ग्राहक सेवा से संपर्क करें',
        setbank: 'कृपया भुगतान कार्ड सेट करें!',
        lorr: 'लॉगिन/पंजीकरण',
    },
    infomation: {
        username: 'सदस्य आईडी',
        name: 'नाम',
        bankcard: 'निकासी खाता',
        phone: 'मोबाइल नंबर',
        recharge: 'रिचार्ज',
        amount: 'स्वामित्व अंक',
        toserve: 'कृपया ग्राहक सेवा से संपर्क करें',
        kfms: 'ऑफलाइन रिचार्ज के लिए, कृपया ग्राहक सेवा से परामर्श करें। कुछ भुगतान चैनलों के रिचार्ज राशि यादृच्छिक रूप से 1 दशमलव स्थान तक रिचार्ज की जाएगी, भुगतान करते समय कृपया अवश्य पुष्टि करें',
    },
    withdraw: {
        title: 'निकासी',
        log: 'निकासी रिकॉर्ड',
        method: 'निकासी विधि',
        avmoney: 'निकासी योग्य शेष',
        limit: 'निकासी सीमा',
        submit: 'निकासी आवेदन',
        xiane: 'प्रति लेनदेन सीमा',
        numbers: 'निकासी संख्या',
        time: 'प्राप्ति समय',
        zuidi: 'न्यूनतम',
        zuigao: 'अधिकतम',
        numsmax: 'प्रतिदिन अधिकतम नकद निकासी',
        ci: 'बार',
        timedetail: 'सामान्य स्थानांतरण समय लगभग 5 मिनट, सबसे तेज 2 मिनट में',
        bank: 'बैंक कार्ड',
        status1: 'समीक्षा स्थिति',
        status2: 'सफल',
        status3: 'विफल',
        enterCorrectAmount: 'कृपया सही राशि दर्ज करें',
        selectBankCard: 'कृपया निकासी बैंक कार्ड चुनें',
        enterPayPassword: 'कृपया भुगतान पासवर्ड दर्ज करें',
    },
    moneylog: {
        title: 'धन विवरण',
        type1: 'परिवर्तन',
        type2: 'बोनस',
        type3: 'कार्य',
        type4: 'पुरस्कार',
        type5: 'निकासी',
        type6: 'निकासी विफल',
        rechargeNote: '(रिचार्ज)',
    },
    setting: {
        loginpwdtitle: 'लॉगिन पासवर्ड बदलें',
        oldpwd: 'कृपया पुराना पासवर्ड दर्ज करें',
        newpwd: 'कृपया नया पासवर्ड दर्ज करें',
        renewpwd: 'कृपया नया पासवर्ड फिर से दर्ज करें',
        change: 'बदलें',
        plseall: 'कृपया पूरा फॉर्म भरें!',
        pswwrong: 'दो बार दर्ज पासवर्ड मेल नहीं खाते',
        paypwdtitle: 'फंड पासवर्ड सेट करें',
        paypwd: 'कृपया फंड पासवर्ड दर्ज करें',
        repaypwd: 'कृपया फंड पासवर्ड फिर से दर्ज करें',
        title: 'सेटिंग',
        basicInfo: 'मूल जानकारी सेटिंग',
        loginPassword: 'लॉगिन पासवर्ड',
        fundPassword: 'फंड पासवर्ड',
        logout: 'लॉगआउट',
        payPasswordSet: 'निकासी पासवर्ड सेट हो चुका है, बदलने के लिए ग्राहक सेवा से संपर्क करें',
        payPasswordNotSet: 'सेट नहीं',
        payPasswordHasSet: 'सेट हो चुका',
        confirm: 'पुष्टि करें',
    },
    home: {
        gonggao: 'परम विलासिता अनुभव का आनंद लें',
        qgkf: 'राष्ट्रव्यापी संभव',
        hotlist: 'लोकप्रिय सिफारिश सूची',
        hotgame: 'कार्य सिफारिश',
        gaoji: 'उन्नत',
        smrz: 'वास्तविक सत्यापन',
        videorz: 'स्वयं वीडियो सत्यापन',
        star: 'रेटिंग',
        sg: 'ऊंचाई',
        xw: 'छाती',
        diqu: 'सेवा क्षेत्र',
        apply: 'मिलने का आवेदन',
        ssxz: 'रीयल-टाइम स्थिति',
        joinvip: 'सदस्यता ली',
    },
    video: {
        title: 'वीडियो गैलरी',
        nums: 'प्ले काउंट',
        bofangliang: 'प्ले काउंट',
        hotlist: 'लोकप्रिय सिफारिश',
        plsrefisrt: 'कृपया वीडियो देखने के लिए रिचार्ज करें!',
        trialEnded: 'ट्रायल समाप्त',
        rechargeToWatch: 'कृपया मुफ्त देखने के लिए रिचार्ज करें',
        goRecharge: 'तुरंत रिचार्ज',
    },
    choose: {
        title: 'सबसे अच्छी रात',
        nav: 'रानी चयन',
        apply: 'मिलान आवेदन',
        jianjie: 'सुंदरी परिचय',
        move: 'स्थानांतरण योग्य',
        click: 'सत्यापन के लिए क्लिक करें',
        detail: 'विस्तृत जानकारी',
        videodetail: 'रीयल-टाइम वीडियो',
    },
    common: {
        refresh: 'सफलतापूर्वक रिफ्रेश',
        noallow: 'फ़ंक्शन अक्षम!',
        disable: 'अक्षम',
        all: 'सभी',
        nomore: 'और नहीं',
        nodata: 'कोई डेटा नहीं',
        submit: 'सबमिट',
        more: 'और देखें',
        pinglunnav: 'टिप्पणी',
        pingluntitle: 'टिप्पणी',
        pldtitle: 'टिप्पणी विवरण',
        minenav: 'खाता',
        homenav: 'होम',
        addbank: 'भुगतान कार्ड जोड़ें',
        setbank: 'निकासी खाता',
    },
    game: {
        expect: 'अवधि संख्या',
        jieguo: 'डेटा',
        da: 'बड़ा',
        xiao: 'छोटा',
        dan: 'विषम',
        shuang: 'सम',
        大: 'बड़ा',
        小: 'छोटा',
        单: 'विषम',
        双: 'सम',
        order: 'कार्य आर्डर',
        clear: 'आर्डर साफ करें',
        submit: 'पुष्टि सबमिट',
        kjcc: 'ड्रा सफल, अवधि संख्या:',
        lxgly: 'कृपया अपने प्रबंधक से संपर्क करें',
        plsmoney: 'कृपया राशि दर्ज करें!',
        plsnum: 'कृपया नंबर चुनें!',
        moneynote: 'शेष राशि अपर्याप्त, कृपया रिचार्ज के लिए ग्राहक सेवा से संपर्क करें!',
        lefttime: 'शेष समय',
        lunci: 'अवधि संख्या',
        workRecord: 'कार्य रिकॉर्ड',
        day: 'दिन',
        period: 'अवधि',
        allWork: 'सभी कार्य',
        reset: 'रीसेट',
        confirm: 'पुष्टि करें',
        bonusPoints: 'बोनस अंक',
        missionMoney: 'कार्य राशि विवरण',
        missionResult: 'कार्य परिणाम',
        points: 'अंक',
        workPoints: 'कार्य अंक',
        giftCompleted: 'उपहार पूरा',
        orderTime: 'आर्डर समय:',
        detail: 'विवरण',
        content: 'सामग्री',
        amount: 'राशि',
        result: 'परिणाम',
        time: 'समय',
        win: 'जीत',
        missionFailed: 'कार्य विफल',
    },
    kefu: {
        title: 'ऑनलाइन ग्राहक सेवा',
        lianxi: 'संपर्क',
        content: '24/7 सेवा',
        defaultName: 'ऑनलाइन ग्राहक सेवा',
    },
    setname: {
        title: 'वास्तविक नाम संशोधित करें',
        xingming: 'नाम',
        tips: 'आपके खाते की सुरक्षा के लिए, वास्तविक नाम लिंक्ड बैंक कार्ड नाम से मेल खाना चाहिए',
        xmpls: 'कृपया वास्तविक नाम दर्ज करें',
        save: 'सहेजें',
        notreset: 'दोबारा सेट न करें!',
        plsentername: 'कृपया नाम दर्ज करें!',
    },
    withdrawCenter: 'निकासी केंद्र',
    withdrawRecord: 'निकासी रिकॉर्ड',
    withdrawAmount: 'निकासी राशि',
    allMoney: 'सभी',
    singleLimit: 'प्रति लेनदेन सीमा',
    lowest: 'सबसे कम',
    highest: 'सबसे अधिक',
    withdrawTimes: 'निकासी संख्या',
    maxDailyWithdraw: 'प्रतिदिन अधिकतम निकासी',
    times: 'बार',
    arrivalTime: 'प्राप्ति समय',
    limitDescription: 'सीमा विवरण',
    balance: 'शेष',
    withdrawNow: 'अभी निकासी',
    enterCorrectAmount: 'कृपया सही राशि दर्ज करें',
    personalReport: 'व्यक्तिगत रिपोर्ट',
    profitAmount: 'लाभ राशि',
    profitFormula: 'लाभ गणना सूत्र: जीत राशि - कार्य राशि',
    taskAmount: 'कार्य राशि',
    accountOffline: 'खाता ऑफलाइन',
    loginRegister: 'लॉगिन/पंजीकरण',
    loginForMore: 'अधिक सेवाओं का आनंद लेने के लिए लॉगिन करें!',
    author: 'लेखक:',
    notification: 'सूचना',
    changePhone: 'मोबाइल नंबर बदलें',
    save: 'सहेजें',
    existingPhone: 'मौजूदा मोबाइल नंबर',
    newPhone: 'नया मोबाइल नंबर',
    withdrawAccountRegister: 'निकासी खाता पंजीकरण',
    selectBankCard: 'कृपया बैंक कार्ड चुनें',
    accountNumber: 'खाता संख्या',
    enterBankCardNumber: 'कृपया बैंक कार्ड नंबर दर्ज करें',
    systemNotice: 'सिस्टम सूचना',
    myMovie: 'मेरी फिल्म',
    completeTaskForMore: 'अधिक मूवी टिकट प्राप्त करने के लिए कार्य पूरा करें',
    movieTicket: 'मूवी टिकट:',
    watchList: 'देखने की सूची',
    noDataYet: 'अभी तक कोई डेटा नहीं',
    setNameFirst: 'निकासी खाता लिंक करने से पहले कृपया नाम सेट करें!',
    setPasswordFirst: 'बैंक कार्ड बाइंड करने से पहले कृपया निकासी पासवर्ड सेट करें!',
    accountHolder: 'खाता धारक',
    enterRealName: 'कृपया वास्तविक नाम दर्ज करें',
    withdrawPassword: 'निकासी पासवर्ड',
    registerWithdrawPassword: 'कृपया निकासी पासवर्ड पंजीकृत करें',
    bankCard: 'बैंक कार्ड',
    orderContentLabel: 'आर्डर सामग्री:',
    all: 'सभी',
    bonusPointsLabel: 'बोनस अंक',
    waitingResultLabel: 'परिणाम की प्रतीक्षा',
    missionMoneyDetails: 'कार्य राशि विवरण',
    points: 'अंक',
    switch: 'स्विच',
    currentSelection: 'वर्तमान चयन:',
    quantity: 'मात्रा:',
    total: 'कुल',
    ticketAmount: 'टिकट संख्या',
    availablePoints: 'उपलब्ध अंक',
    verify: 'सत्यापन',
    possible: 'संभव',
    thumb: 'अंगूठा',
    privacyPolicy: 'गोपनीयता नीति',
    romanticDescription: 'हमारी रोमांटिक सेवा सदस्यों की व्यक्तिगत जानकारी की सुरक्षा के लिए, केवल वास्तविक नाम सत्यापन सेवा के माध्यम से या सत्यापित सदस्य द्वारा सिफारिश से ही पंजीकरण संभव है।',
    person1: 'ज़िया यू',
    person2: 'मिन ज़ू',
	lishijl: 'इतिहास रिकॉर्ड'
};